import Picklist from './Picklist';
import MultiselectLabels from './MultiselectLabels.vue';
import MultiselectCheckboxes from './MultiselectCheckboxes.vue';

export default {
  picklist: Picklist,
  multiselectLabels: MultiselectLabels,
  multiselectCheckboxes: MultiselectCheckboxes,
};
